module.exports = __webpack_public_path__ + "static/media/IMG-20230508-WA0178.91e570d4.jpg";